import React from 'react';
import { Constants } from '@pwc/pwc-deals-web-common';
import PageAuditFields from '../PageAuditFields/PageAuditFields';
import ShowForRole from '../../../features/security/ShowForRole';
import PillContainer from '../Pills/PillContainer';

const StatusViewer = ({
  projectId,
  content,
  allowDraftPill,
  className,
  shareWithAll,
}) => {
  const hideVersionStatus = true;
  return (
    <>
      <ShowForRole
        projectId={projectId}
        roles={Constants.USER_ROLE_GROUPS.INTERNAL}
      >
        <PageAuditFields
          dateShared={content.dateShared}
          dateModified={content.dateModified}
          modifiedBy={content.modifiedBy}
          shareWithAll={shareWithAll}
        />
      </ShowForRole>
      <PillContainer
        projectId={projectId}
        content={content}
        allowDraftPill={allowDraftPill}
        className={className}
        hideVersionStatus={hideVersionStatus}
      />
    </>
  );
};

export default StatusViewer;
